import Moment from 'react-moment';
import { Typography, Box, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect  } from "react";
import { clearMessage, setMessage } from "../../slices/message";
import { getCollection } from '../../slices/collection';


const NiceCollection = (props) => {

  const dispatch = useDispatch();
  //debugger;
  const collection = useSelector((state) => state.collection.data.list?.find(collection => collection.id === props.children));

  useEffect(() => {
    if(!collection){
      //need to get the collection to display 
      //debugger;
      let id = props.children;

      dispatch(getCollection({id}));
    };

}, [collection]);

return (
  <>
  {collection &&
  <Box>
    <Typography>{collection.name}</Typography> 
    {props.withID &&
      <Typography variant="small">({collection.id})</Typography>
    }
    </Box>
}
</>)
}

export default NiceCollection;